import React from 'react';
import PropTypes from 'prop-types';

const CheckboxComponent = (props) => {
    const checked = props.checked;
    return (<input style={props.style} type={'checkbox'} className={''} name={props.name} checked={checked} onChange={()=>props.onChange(!checked)} disabled = {props.isDisabled} />)
};

CheckboxComponent.propTypes = {
    type: PropTypes.string,
    name: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string
}

export default CheckboxComponent;